import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import {
  getClassroomAvailabilityActionRequest,
  getContinuousEducationSectionActionRequest,
  getContinuousEducationSectionSchedulesActionRequest,
  updateContinuousEducationSectionSchedulesActionRequest,
} from '../api';
import {
  ContinuousEducationSectionClassroomLoaderFilters,
  UpdateContinuousEducationSectionSchedules,
} from '../types';

const getContinuousEducationSectionAction = actionKitImpFunction(
  async (id: string | number) => {
    const response = await getContinuousEducationSectionActionRequest(id);
    if (response.error) {
      return null;
    }

    const { data } = response;

    return data;
  },
);

const getContinuousEducationSectionSchedulesAction = actionKitImpFunction(
  async (id: string | number) => {
    const response = await getContinuousEducationSectionSchedulesActionRequest(
      id,
    );
    if (response.error) {
      return null;
    }

    const { data } = response;

    return data;
  },
);

const updateContinuousEducationSectionSchedulesAction = actionKitImpFunction(
  async (
    id: string | number,
    data: UpdateContinuousEducationSectionSchedules,
  ) => {
    const response = await updateContinuousEducationSectionSchedulesActionRequest(
      id,
      data,
    );
    if (response.error) {
      throw new Error('Error updating section schedules');
    }
    return response.data;
  },
);

const getClassroomAvailabilityAction = actionKitImpFunction(
  async (
    data: ContinuousEducationSectionClassroomLoaderFilters & {
      sectionId: number | string;
    },
  ) => {
    const response = await getClassroomAvailabilityActionRequest(data);
    if (response.error) {
      throw new Error('Error getting classroom availability');
    }
    return response.data;
  },
);

export {
  getContinuousEducationSectionAction,
  getContinuousEducationSectionSchedulesAction,
  updateContinuousEducationSectionSchedulesAction,
  getClassroomAvailabilityAction,
};
